import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { Fragment, type Props } from '../fragment'
import { ScreenClassProvider } from '@vp/swan'

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(
    <ScreenClassProvider>
      <Fragment {...renderProps} />
    </ScreenClassProvider>,
    rootElement,
    rootOptions,
  )
}
